import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';
import { ForgotPasswordVm } from 'app/shared/generated/Models/ForgotPasswordVm';

@Component({
    selector: 'pcg-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnDestroy, AfterViewInit {

	@ViewChild('footerEl', { static: true }) footerEl: ElementRef;

	forgotPasswordForm = ForgotPasswordVm.Form;
	forgotPasswordSub: Subscription = new Subscription();
	checkEmail = false;

	constructor(private ms: SystemMessageService, public router: Router) { }

    ngAfterViewInit() {
		const footContainer = document.querySelector('#footer .container');
		footContainer?.insertBefore(this.footerEl.nativeElement, footContainer.firstChild);
    }

	onSubmit() {
		if (this.forgotPasswordForm.valid) {
			this.forgotPasswordSub.add(this.ms.getHttpObservable(this, 'api/Account/ForgotPassword', this.forgotPasswordForm)
				.subscribe(msg => { if (msg?.isSuccessful) { this.checkEmail = true; } }));
		} else { validateForm(this.forgotPasswordForm); }
	}

	ngOnDestroy() {
		this.forgotPasswordSub.unsubscribe();
		this.footerEl.nativeElement.parentNode.removeChild(this.footerEl.nativeElement);
	}
}
